<template>
  <ul class="header-controls header-controls--back">
    <router-link
      tag="li"
      :to="`/thread-id-${$route.params.id}`"
      class="header-controls__item"
    >
      <i class="material-icons md-24 color_white">
        chevron_left
      </i>
    </router-link>
  </ul>
</template>

<script>
export default {
  name: 'BackButton',
};
</script>

<style>
  .header-controls {
    padding: 0;
    margin: 0 20px 0 0;
    list-style: none;
  }

  .header-controls__item {
    padding: 4px 5px 1px 6px;
    background-color: #0084ff;
    box-sizing: border-box;
    cursor: pointer;
  }
</style>
